<template>
  <div id="school-tour">
    <p>We will contact you to schedule a tour.
    Please answer the remaining questions to help us tailor your tour.</p>
    <page-controls path="/academic-interests/0"/>
  </div>
</template>

<script>
export default {
  name: 'SchoolTour',
};
</script>

<style lang="scss">
#school-tour {
    display: flex;
    flex-direction: column;
    min-height: 80vh;
    p {
        max-width: 45rem;
        color: white;
        font-size: 2rem;
        margin: auto auto;
        padding: 0 2rem;
    }
}

@media (min-width: 49rem){
    #school-tour {
        p { padding: 0; }
    }
}
</style>

